import { apiApp } from "/src/config/api";
const endpoint = "admin/video";

const getVideo = () => apiApp.get(endpoint);
const createVideo = data => apiApp.post(endpoint, data);

export { getVideo, createVideo };
